import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';

import Notifier, { openSnackbar } from '../components/notifier';

import api from '../api/backend'

import ReactGA from 'react-ga';

const styles = theme => ({
    layout: {
        height: '100vh',
        width: 'auto',
        display: 'block', // Fix IE11 issue.
        // marginLeft: theme.spacing.unit * 3,
        // marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
        paddingTop: 64,
        backgroundColor: '#f8982b'
    },
    paper: {
        maxWidth: 400,
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
        // borderRadius: 0,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
});

class SignIn extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { email: '', password: '' }
    }

    componentDidMount() {
        ReactGA.initialize('UA-141674580-1');
        ReactGA.pageview('SignIn');
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const { email, password } = this.state
        console.log('login with', email, password)
        ReactGA.event({
            category: 'Login',
            action: `Login with [${email}]`
          })
        api.login(email, password).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                sessionStorage.setItem('user', JSON.stringify(json))
                this.props.history.push('/')
            } else if(response.status === 409) {
                openSnackbar({ message: 'กรุณารอการอนุมัติจากทางสถาบัน' })
            } else {
                console.error('login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง')
                openSnackbar({ message: 'login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง' })
            }
        }).catch(() => {
            console.error('login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง')
                openSnackbar({ message: 'login ไม่สำเร็จกรุณาลองใหม่อีกครั้ง' })
        })
    }

    render() {
        const { classes } = this.props
        return (
            <React.Fragment>
                <CssBaseline />
                <main className={classes.layout}>
                    <Notifier />
                    <center>
                    <Paper className={classes.paper}>
                        {/* <Avatar className={classes.avatar}>
                            <LockIcon />
                        </Avatar> */}
                        <Typography variant="display2" style={{ padding: 20 }}>ติวเตอร์ครูก้อ</Typography>
                        {/* <Typography variant="headline">ลงชื่อเข้าใช้งาน</Typography> */}
                        <form className={classes.form} onSubmit={this.handleSubmit}>
                            <FormControl margin="normal" required fullWidth>
                                {/* <InputLabel htmlFor="email">Username</InputLabel> */}
                                <Input id="email" name="email" autoComplete="email" autoFocus
                                placeholder="Username / Email"
                                    onChange={(e) => {
                                        this.setState({ email: e.target.value })
                                    }} />
                            </FormControl>
                            <FormControl margin="normal" required fullWidth>
                                {/* <InputLabel htmlFor="password">Password</InputLabel> */}
                                <Input
                                    name="password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    placeholder="Password"
                                    onChange={(e) => {
                                        this.setState({ password: e.target.value })
                                    }}
                                />
                            </FormControl>
                            <Button
                                type="submit"
                                fullWidth
                                variant="raised"
                                color="primary"
                                className={classes.submit}
                            >
                                ลงชื่อเข้าใช้
            </Button>
            <Button
                                fullWidth
                                variant="raised"
                                color="default"
                                className={classes.submit}
                                onClick={() => {
                                    this.props.history.push('/register')
                                }}
                            >
                                ลงทะเบียนเข้าใช้งาน
            </Button>
                        </form>
                    </Paper>
                    </center>
                </main>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(SignIn);